import { h } from 'preact';
import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { MessageSummary } from '@oracle/oraclejet-preact/UNSAFE_Message';

describe('Test MessageSummary component', () => {
  it('text', async function () {
    const content = render(
      <MessageSummary
        text='My Message Summary'
      />
    );

    const summary = await content.findByText('My Message Summary');
    expect(summary).not.null;
  });
});
